import { RelationshipFieldMany } from "../plugins/Cruxtify/field-types";

export class PricedComponentMappingField extends RelationshipFieldMany {
  public static fieldName = "PricedComponentMappingField";

  public fieldWidth: string = "full";
  protected _label: string = "Priced Components Mapping";
}
